import React, { useEffect } from 'react';
import { sendLiveRegionMessage } from '../../../components/atoms/LiveRegionGlobal/LiveRegionGlobal';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Heading } from '../Heading/Heading';
import { StatusInfoError } from '../StatusInfo';
import { StatusInfoModifier } from '../StatusInfo/partials/StatusInfo';

type UploadErrorsProps = {
  id: string;
  errors: string[];
};

export function ImageUploadValidationErrors({ id, errors }: UploadErrorsProps) {
  const { t } = useSonTranslation('ImageUpload');
  const errorsHash = errors.join();
  useEffect(() => {
    if (errorsHash !== '') {
      sendLiveRegionMessage(t('errorMessageLiveRegion'));
    }
  }, [errorsHash, t]);

  // This condition prevents empty ul
  return errors.length === 0 ? null : (
    <div className="image-upload__validation-errors">
      <Heading
        id={`image-validation-errors-headline-${id}`}
        hierarchy={4}
        className="image-upload__validation-errors-headline font-bold-15-19"
      >
        {t('validationErrorHeadline')}
      </Heading>
      <ul className="image-upload__validation-errors-list">
        {errors.map(error => (
          <li className="image-upload__validation-errors-list-item" key={error}>
            <StatusInfoError message={error} modifier={StatusInfoModifier.MARGIN_BOTTOM} />
          </li>
        ))}
      </ul>
    </div>
  );
}
